import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { deleteRepatriationsTransactionsDeleteRequestActionCreator } from '../redux/actions/InternalRepatriationsTransactionsDeleteActions';

class InternalRepatriationsTransactionsDeleteDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: props.row.row.description,
      transactionId: props.row.row.id,
    };
    this.confirmEdit = this.confirmEdit.bind(this);
  }

  async confirmEdit() {
    await this.props.deleteRepatriationsTransactionsDeleteRequestActionCreator(
      this.props.appContext,
      this.state.comments,
      this.state.transactionId,
    );
    this.props.closeDialog();
    await this.props.refreshTransactions();
    this.props.refreshHistories();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Delete Transaction</DialogTitle>
        <div>
          <p style={{ padding: '5px' }}>Are you sure you want to delete these transactions?</p>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmEdit}
            className="primary-button-false"
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

InternalRepatriationsTransactionsDeleteDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  deleteRepatriationsTransactionsDeleteRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteRepatriationsTransactionsDeleteRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalRepatriationsTransactionsDeleteDialog);
